import { useCallback, useEffect, useState } from 'react';
import AdvancedFilters, {
  AdvancedFiltersProps,
  AdvancedFiltersState,
} from 'src/components/AdvancedFilters';
import {
  useGetCancellationConfirmationStatusOptions,
  useGetCancellationFilters,
  useGetCancellationKindOptions,
  useGetCancellationReasonOptions,
  useGetCancellationStatusOptions,
} from 'src/pages/CancellationsPage/api';

export function CancellationFilters({
  open,
  filters,
  handleSearch,
}: AdvancedFiltersProps) {
  const [advancedFilters, setAdvancedFilters] = useState<
    AdvancedFiltersState[]
  >([{}]);

  useEffect(() => {
    setAdvancedFilters(filters.length ? filters : [{}]);
  }, [open, filters]);

  const { data } = useGetCancellationFilters({ enabled: open });
  const { data: cancellationKindOptions } = useGetCancellationKindOptions({
    enabled: false,
  });
  const { data: cancellationReasonOptions } = useGetCancellationReasonOptions({
    enabled: false,
  });
  const { data: cancellationStatusOptions } = useGetCancellationStatusOptions({
    enabled: open,
  });
  const { data: cancellationConfirmationStatusOptions } =
    useGetCancellationConfirmationStatusOptions({
      enabled: open,
    });

  const dynamicOptions = useCallback(
    (options: { version: string; uri: string }) => {
      if (options.uri === 'cancellation_notices/reason_options') {
        return cancellationReasonOptions;
      }
      if (options.uri === '/cancellation_notices/kind_options') {
        return cancellationKindOptions;
      }
      if (options.uri === '/cancellation_notices/statuses') {
        return cancellationStatusOptions;
      }
      if (options.uri === '/cancellation_notices/confirmation_statuses') {
        return cancellationConfirmationStatusOptions;
      }
    },
    [
      cancellationKindOptions,
      cancellationReasonOptions,
      cancellationStatusOptions,
      cancellationConfirmationStatusOptions,
    ],
  );

  return (
    <AdvancedFilters
      open={open}
      data={data}
      filters={advancedFilters}
      handleSearch={handleSearch}
      setFilters={setAdvancedFilters}
      dynamicOptions={dynamicOptions}
    />
  );
}
